<template>
  <div class="issue-con">
    <span class="priority-label" :class="'priority-' + issuePriority">{{priorityLabel}}优问题</span>
    <div class="issue-list">
      <issue-item v-for="(issue, i) in showList" :key="issue.key" :issue="issue" :is-index="isIndex" :hasCharge="hasCharge"></issue-item>
    </div>
    <span class="more-act" v-if="isIndex && issueList.length > MAX_SHOW_COUNT[issuePriority]" @click="toggleFold">
      {{fold ? '展开' : '收起'}}<i :class="{'el-icon-arrow-down': fold, 'el-icon-arrow-up': !fold}"></i>
      <common-popover v-if="showPop" msg="点击查看更多待优化内容" btn-text="我知道了" pop-key="suggestMore" :styleCss="styleCss"></common-popover>
    </span>
  </div>
</template>
<script>
  import IssueItem from './IssueItem.vue';
  import CommonPopover from 'components/CommonPopover.vue';
  import {ISSUE_BTN_LABEL, ISSUE_BTN_LINK, ISSUE_BTN_NEXT, INDEX_BTN_LABEL} from '../utils/const.js';
  const MAX_SHOW_COUNT = {
    1: 3,
    2: 2,
    3: 1
  };
  export default {
    name: 'issue-container',
    props: {
      showPop: Boolean,
      isIndex: Boolean,
      issuePriority: {
        type: Number,
        default: 1
      },
      issueList: {
        type: Array,
        default: () => []
      },
      hasCharge: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        fold: this.isIndex ? true : false,
        styleCss: {
          right: '0px',
          top: '26px'
        },
        MAX_SHOW_COUNT
      }
    },
    computed: {
      priorityLabel() {
        return {
          1: '高',
          2: '中',
          3: '低'
        }[this.issuePriority];
      },
      list() {
        return this.issueList.map(item => {
          item.btnLabel = this.isIndex && INDEX_BTN_LABEL[item.key] ? INDEX_BTN_LABEL[item.key] : ISSUE_BTN_LABEL[item.key];
          item.btnLink = ISSUE_BTN_LINK[item.key];
          item.component = this.isIndex && INDEX_BTN_LABEL[item.key] ? ISSUE_BTN_NEXT[item.key] : '';
          return item;
        })
      },
      showCount() {
        const count = MAX_SHOW_COUNT[this.issuePriority];
        return this.isIndex && this.fold ? count : this.list.length;
      },
      showList() {
        const len = Math.min(this.showCount, this.list.length);
        return this.list.slice(0, len);
      }
    },
    watch: {
      issueList(newVal) {
        if (newVal.length > this.showCount) {
          this.fold = true;
        } else {
          this.fold = false;
        }
      }
    },
    components: {
      IssueItem,
      CommonPopover
    },
    methods: {
      toggleFold() {
        this.fold = !this.fold;
      }
    },
  }
</script>
<style lang="scss">
  .issue-con {
    position: relative;
    width: 100%;
    padding: 22px 30px;
    margin-top: 14px;
    background: #fff;
    border-radius: 12px;
    overflow: visible;
    .priority-label {
      position: absolute;
      top: 2px;
      left: 2px;
      width: 64px;
      height: 24px;
      font-size: 12px;
      line-height: 24px;
      text-align: center;
      border-radius: 12px;
      &.priority-1 {
        background: linear-gradient(90deg, #FDF3ED 6.82%, #F7D3CF 95.45%);
        color: #D72121;
      }
      &.priority-2 {
        background: linear-gradient(90deg, #FFF2E5 0%, #FFE9D3 100%);
        color: #E9782A;
      }
      &.priority-3 {
        background: linear-gradient(270deg, #F2F2F2 20.31%, #F3F3F4 100%);
        color: #868686;
      }
    }
    .more-act {
      position: absolute;
      right: 10px;
      bottom: 4px;
      font-size: 12px;
      color: #636363;
      cursor: pointer;
    }
  }
</style>